import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import { MouseEvent, useEffect, useState } from 'react';
import { MdAutorenew, MdDoneAll, MdExpandLess, MdExpandMore, MdStar } from 'react-icons/md';
import classes from './DashboardToolbar.module.scss';

export enum DashboardToolbarOptions {
  AllSurveys = 'AllSurveys',
  TopSurveys = 'TopSurveys',
  OngoingSurveys = 'OngoingSurveys',
}

export type Props = {
  className?: string;
  filter?: DashboardToolbarOptions;
  onChanged?: (option: DashboardToolbarOptions) => void;
};

export default function DashboardToolbar({ onChanged, className, filter }: Props) {
  const [active, setActive] = useState<DashboardToolbarOptions | undefined>(
    DashboardToolbarOptions.AllSurveys,
  );
  useEffect(() => {
    if (filter) {
      setActive(filter);
    }
  }, [filter]);
  const [mobileOverflowMenuOpen, setMobileOverflowMenuOpen] = useState(false);

  function handleOptionClick(e: MouseEvent<HTMLElement>) {
    let target = e.target as HTMLElement;
    while (target.dataset.option === undefined && target.parentElement !== null) {
      target = target.parentElement as HTMLElement;
    }
    if (target.dataset.option) {
      setActive(target.dataset.option as DashboardToolbarOptions);
      if (onChanged) {
        onChanged(target.dataset.option as DashboardToolbarOptions);
      }
    }

    setMobileOverflowMenuOpen((prev) => !prev);
  }

  return (
    <div className={clsx(classes.root, className)}>
      <ul className={clsx(classes.menu)}>
        <li
          data-option={DashboardToolbarOptions.AllSurveys}
          className={clsx(
            classes.allSurveys,
            active === DashboardToolbarOptions.AllSurveys && classes.active,
          )}
          onClick={handleOptionClick}
        >
          <MdDoneAll className={clsx(classes.icon)} />
          <Txt>All Surveys</Txt>
          <div className={clsx(classes.mobileOverflowMenuToggle)}>
            {mobileOverflowMenuOpen ? (
              <MdExpandLess className={clsx(classes.icon)} />
            ) : (
              <MdExpandMore className={clsx(classes.icon)} />
            )}
          </div>
        </li>
        <li
          data-option={DashboardToolbarOptions.TopSurveys}
          className={clsx(
            classes.topSurvey,
            active === DashboardToolbarOptions.TopSurveys && classes.active,
          )}
          onClick={handleOptionClick}
        >
          <MdStar className={clsx(classes.icon, classes.topSurveyIcon)} />
          <Txt>Top Surveys</Txt>
          <div className={clsx(classes.mobileOverflowMenuToggle)}>
            {mobileOverflowMenuOpen ? (
              <MdExpandLess className={clsx(classes.icon)} />
            ) : (
              <MdExpandMore className={clsx(classes.icon)} />
            )}
          </div>
        </li>
        <li
          data-option={DashboardToolbarOptions.OngoingSurveys}
          className={clsx(
            classes.ongoingSurvey,
            active === DashboardToolbarOptions.OngoingSurveys && classes.active,
          )}
          onClick={handleOptionClick}
        >
          <MdAutorenew className={clsx(classes.icon, classes.ongoingSurveyIcon)} />
          <Txt>Ongoing Surveys</Txt>
          <div className={clsx(classes.mobileOverflowMenuToggle)}>
            {mobileOverflowMenuOpen ? (
              <MdExpandLess className={clsx(classes.icon)} />
            ) : (
              <MdExpandMore className={clsx(classes.icon)} />
            )}
          </div>
        </li>
      </ul>
      {mobileOverflowMenuOpen && (
        <div className={clsx(classes.mobileOverflowMenu)}>
          <ul>
            <li
              data-option={DashboardToolbarOptions.AllSurveys}
              className={clsx(
                classes.allSurveys,
                active === DashboardToolbarOptions.AllSurveys && classes.active,
              )}
              onClick={handleOptionClick}
            >
              <MdDoneAll className={clsx(classes.icon)} />
              <Txt>All Surveys</Txt>
            </li>
            <li
              data-option={DashboardToolbarOptions.TopSurveys}
              className={clsx(
                classes.topSurvey,
                active === DashboardToolbarOptions.TopSurveys && classes.active,
              )}
              onClick={handleOptionClick}
            >
              <MdStar className={clsx(classes.icon, classes.topSurveyIcon)} />
              <Txt>Top Surveys</Txt>
            </li>
            <li
              data-option={DashboardToolbarOptions.OngoingSurveys}
              className={clsx(
                classes.ongoingSurvey,
                active === DashboardToolbarOptions.OngoingSurveys && classes.active,
              )}
              onClick={handleOptionClick}
            >
              <MdAutorenew className={clsx(classes.icon, classes.ongoingSurveyIcon)} />
              <Txt>Ongoing Surveys</Txt>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
